import React from "react";
import { Params } from "./types";
import { ImageLogo } from "./styles";

const Logo = ({ height }: Params) => {
    return <ImageLogo height={height} src=".\images\logoIcon.svg" />;
};

export default Logo;
